<template>
  <div style="padding: 10px">
    <div class="mt10">
      <el-row>
        <el-col>
          <el-button type="primary" @click="addManage()">添加用户</el-button>
          <el-button type="primary" @click="addFle">批量导入</el-button>
        </el-col>
      </el-row>
      <div class="search-box">
        <el-input
          placeholder="搜索用户"
          class="input-with-select"
          size="medium"
          v-model="keyword"
          @keyup.enter.native="searchTo()"
        >
          <el-button
            @click="searchTo()"
            :loading="tableLoading"
            slot="append"
            icon="el-icon-search"
            title="搜索"
          ></el-button>
        </el-input>
      </div>
      <pagination-table
        ref="table"
        :data="tableData"
        :columns="columns"
        :actions="actions"
        :loader="fetchUserInfo"
        :async="true"
        :pageSizes="[20]"
        colWidth="400px"
      ></pagination-table>
    </div>
    <el-dialog
      v-drag:common
      :title="dialog.isEdit ? '编辑用户' : '新增用户'"
      :visible="dialog.visible"
      @close="dialog.visible = false"
      width="500px"
    >
      <el-form
        class="mt20 mr30"
        :rules="dialog.rule"
        label-width="80px"
        label-position="right"
        :model="dialog.data"
        ref="dialog"
      >
        <el-row>
          <el-form-item label="用户名" prop="userCode">
            <el-input v-model="dialog.data.userCode"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="dialog.data.name"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="userMail">
            <el-input v-model="dialog.data.userMail"></el-input>
          </el-form-item>
          <!-- <el-form-item label="密码" prop="password">
            <el-input v-model="dialog.data.password"></el-input>
          </el-form-item>-->
          <el-form-item label="手机号" prop="userTel">
            <el-input v-model="dialog.data.userTel"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="state">
            <el-radio v-model="dialog.data.state" label="0">禁用</el-radio>
            <el-radio v-model="dialog.data.state" label="1">启用</el-radio>
          </el-form-item>
          <el-form-item label="角色" prop="role">
            <el-select
              v-model="dialog.data.roleId"
              @change="selectChange"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row class="mb20">
          <el-form-item>
            <el-col :span="12" align="center">
              <el-button
                :disabled="dialog.isReadOnly"
                @click="save()"
                type="primary"
                :loading="dialog.loading"
                >{{ dialog.isEdit ? '保存' : '添加' }}</el-button
              >
            </el-col>
            <el-col :span="12" align="left">
              <el-button @click="dialog.visible = false">取消</el-button>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog
      v-drag:common
      title="批量导入"
      :visible="visible"
      :show-close="false"
    >
      <el-form class="demo-form-inline transtant-input">
        <el-form-item label="数据文件" label-width="80px">
          <el-row>
            <el-col :span="10">
              <el-upload
                ref="upload"
                :action="action"
                :data="headers"
                :auto-upload="false"
                :on-success="onFileUploadSuccess"
                accept=".xls, .xlsx"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-col>
            <el-col :span="5">
              <el-link
                underline
                :style="{
                  color: '#fff',
                  borderBottom: '1px solid #fff',
                  fontSize: '12px'
                }"
                target="blank"
                :href="hrefUrl"
                download
                >模板下载</el-link
              >
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils';

export default {
  data() {
    return {
      visible: false,
      headers: {
        apiKey: getToken()
      },
      tableData: [],
      // 获取角色列表
      roleList: [],
      tableLoading: false,
      page: 0,
      keyword: '',
      hrefUrl: `${process.env.VUE_APP_TEMPLATE_HOST}/批量创建用户模板.xlsx`,
      action: `${process.env.VUE_APP_API_HOST_MANAGE}/manage/user/uploadFile`,
      columns: [
        {
          prop: 'userCode',
          label: '用户名'
        },
        {
          prop: 'name',
          label: '姓名'
        },
        {
          prop: 'userMail',
          label: '邮箱'
        },
        {
          prop: 'userTel',
          label: '手机号'
        },
        {
          prop: 'state',
          label: '状态',
          render: (y, scope) => {
            if (scope.row.state === 0) {
              return <span>禁用</span>;
            } else {
              return <span>启用</span>;
            }
          }
        },
        {
          prop: 'roleName',
          label: '角色'
        }
      ],
      actions: [
        {
          label: '修改',
          type: 'primary',
          plain: true,
          style: 'btn',
          onClick: (index, row) => {
            this.edit(row);
          }
        },
        {
          label: '删除',
          type: 'danger',
          plain: true,
          style: 'btn',
          onClick: (index, row) => {
            this.del(row);
          }
        },
        {
          label: '重置密码',
          type: 'danger',
          plain: true,
          style: 'btn',
          onClick: (index, row) => {
            this.reset(row);
          }
        }
      ],
      dialog: {
        isEdit: false,
        visible: false,
        isReadOnly: false,
        loading: false,
        rule: {
          userCode: [
            {
              required: true,
              message: '请输入用户名',
              trigger: 'blur'
            },
            {
              min: 2,
              max: 10,
              message: '长度在2到10个字符',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value.trim()) {
                  callback();
                } else {
                  callback(new Error('请输入正确的用户名'));
                }
              },
              trigger: 'blur'
            }
          ],
          name: [
            {
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            },
            {
              min: 2,
              max: 10,
              message: '长度在2到10个字符',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value.trim()) {
                  callback();
                } else {
                  callback(new Error('请输入正确的姓名'));
                }
              },
              trigger: 'blur'
            }
          ],
          userMail: [
            {
              required: true,
              message: '请输入邮箱地址',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  return callback();
                }
                let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                if (String(value).match(reg)) {
                  callback();
                } else {
                  callback(new Error('请输入正确的邮箱地址'));
                }
              },
              trigger: 'blur'
            }
          ],
          userTel: [
            {
              required: true,
              message: '请输入联系电话',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (String(value).match(/^1[3-9]\d{9}$/)) {
                  callback();
                } else {
                  callback(new Error('请输入正确的手机号'));
                }
              },
              trigger: 'blur'
            }
          ],
          state: [
            {
              required: true,
              message: '请选择状态',
              trigger: 'blur'
            }
          ]
          // role: [
          //   {
          //     required: true,
          //     message: '请选择角色',
          //     trigger: 'blur'
          //   }
          // ]
        },
        data: {}
      }
    };
  },
  computed: {
    // userCode() {
    //   //console.log(this.$state);
    //   return this.$state;
    // }
  },
  watch: {
    customerKeyword(keywords) {
      if (!keywords) {
        this.roleId = null;
      }
    }
  },
  methods: {
    addFle() {
      this.visible = true;
    },
    cancel() {
      this.visible = false;
      this.$refs.upload.clearFiles();
    },
    async fetchUserInfo(options) {
      this.tableLoading = true;
      const res = await this.$fetch('/manage/user/getUserList', {
        module: 'manage',
        params: { pageNo: options.page, keyword: this.keyword },
        showError: true
      });
      const data = res.data.data.rows;
      data.forEach(item => {
        this.roleList.forEach(val => {
          if (item.roleId === val.roleId) {
            item.roleName = val.roleName;
          }
        });
      });
      this.tableData = data;
      this.tableLoading = false;
      return {
        data: res.data.data.rows,
        total: res.data.data.total
      };
    },
    async submit() {
      this.$refs.upload.submit();
    },
    async onFileUploadSuccess(response) {
      this.$refs.upload.clearFiles();
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        this.visible = false;
        setTimeout(() => {
          location.reload();
        }, 1000);
        return;
      }
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    async fetchRole() {
      const res = await this.$fetch('/manage/roleManage/getRoleList', {
        module: 'manage',
        showError: true
      });
      this.roleList = res.data.defaultParam;
    },
    edit(val) {
      this.dialog.isEdit = true;
      this.dialog.visible = true;

      this.dialog.data = Object.assign(
        {
          createTime: val.createTime,
          lastLoginTime: val.lastLoginTime,
          name: val.name,
          userCode: val.userCode,
          userMail: val.userMail,
          userTel: val.userTel,
          roleId: val.roleId,
          state: val.state,
          userId: val.userId
        },
        val
      );
      this.dialog.data.state = this.dialog.data.state.toString();
      if (this.$refs.dialog) {
        this.$refs.dialog.clearValidate();
      }
    },
    addManage() {
      this.dialog.visible = true;
      this.dialog.isEdit = false;
      this.dialog.data = {
        createTime: '',
        lastLoginTime: '',
        name: '',
        userCode: '',
        userMail: '',
        userTel: '',
        roleId: '',
        state: '1',
        userId: ''
      };
      this.dialog.data.state = '1';
      if (this.$refs.dialog) {
        this.$refs.dialog.clearValidate();
      }
    },
    del(val) {
      this.$confirm(`确定删除用户"${val.name}"？`,{closeOnClickModal: false}).then(() => {
        this.$postForm('/manage/user/delUser', {
          module: 'manage',
          params: {
            userId: val.userId
          },
          showError: true,
          showSuccess: true
        }).then(() => {
          this.$refs.table.load();
        });
      });
    },
    reset(val) {
      this.$confirm(`确定将用户"${val.name}"的密码重置？`,{closeOnClickModal: false}).then(() => {
        this.$postForm('/manage/user/resetPassword', {
          module: 'manage',
          params: {
            userId: val.userId
          },
          showError: true,
          showSuccess: true
        }).then(() => {
          this.$refs.table.load();
        });
      });
    },
    selectChange(val) {
      this.dialog.roleId = val;
    },
    save() {
      this.$refs.dialog.validate().then(() => {
        this.dialog.loading = true;
        let url = `/manage/user/saveUser?apiKey=${getToken()}`;
        // 编辑用户
        this.$fetch({
          url: url,
          method: 'post',
          data: {
            createTime: this.dialog.data.createTime,
            lastLoginTime: this.dialog.data.lastLoginTime,
            name: this.dialog.data.name,
            userCode: this.dialog.data.userCode,
            userMail: this.dialog.data.userMail,
            userTel: this.dialog.data.userTel,
            roleId: this.dialog.data.roleId,
            state: Number(this.dialog.data.state),
            userId: this.dialog.data.userId
          },
          module: 'manage',
          showError: true,
          showSuccess: true
        })
          .then(() => {
            this.dialog.loading = false;
            this.dialog.visible = false;
            return this.$refs.table.load();
          })
          .catch(() => {
            this.dialog.loading = false;
          });
      });
    },
    searchTo() {
      this.$refs.table.load({ page: 1 });
    }
  },
  created() {
    this.fetchRole();
  }
};
</script>

<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
a {
  text-decoration: none;
}
.danger {
  color: red;
}

/deep/.el-form-item {
  font-size: 12px;

  .el-form-item__label {
    color: #fff;
  }
}
.search-box {
  margin: 10px 0;
  .input-with-select {
    width: 400px;
  }
}
</style>
